import {
  Home, Receipt, LineChart, Banknote, Settings, Wallet, CalendarClock, Percent,
  Building2, Repeat2, Users, ShoppingBag, Coins, ScanLine, FileText, ContactRound,
} from 'lucide-react';

// `group` drives the mobile "Plus" sheet sections; `requires` gates visibility.
export const NAV_ITEMS = [
  { to: '/', label: 'Accueil', Icon: Home, exact: true },
  { to: '/depenses/transactions', label: 'Transactions', Icon: Receipt },
  { to: '/cash-flow', label: 'Cash-flow', Icon: LineChart },
  { to: '/a-payer', label: 'À payer', Icon: CalendarClock, group: 'Pilotage' },
  { to: '/factures', label: 'Factures clients', Icon: FileText, group: 'Ventes & clients' },
  { to: '/previsionnels', label: 'Prévisionnels', Icon: Wallet },
  { to: '/employes', label: 'Employés', Icon: Users, group: 'Société' },
  { to: '/dettes', label: 'Dettes', Icon: Banknote, group: 'Pilotage' },
  { to: '/tva', label: 'TVA', Icon: Percent, group: 'Pilotage' },
  { to: '/justificatifs', label: 'Justificatifs', Icon: ScanLine, group: 'Pilotage' },
  { to: '/refacturation', label: 'Refacturation', Icon: Repeat2, group: 'Société', requires: 'group' },
  { to: '/ventes', label: 'Ventes', Icon: ShoppingBag, group: 'Ventes & clients', requires: 'shopify' },
  { to: '/caisse', label: 'Caisse', Icon: Coins, group: 'Société' },
  { to: '/associes', label: 'Associés', Icon: ContactRound, group: 'Société' },
  { to: '/settings', label: 'Paramètres', Icon: Settings, group: 'Réglages' },
  { to: '/admin/entities', label: 'Admin entités', Icon: Building2, group: 'Réglages', admin: true },
];

export const MOBILE_TAB_PATHS = ['/', '/depenses/transactions', '/cash-flow', '/previsionnels'];

export const MORE_GROUPS = ['Pilotage', 'Ventes & clients', 'Société', 'Réglages'];

export function visibleNavItems({ isLoading, isGroup, memberships, activeMembership }) {
  const groupEligible = memberships.filter((m) => m.include_in_group);
  // Refacturation needs ≥ 2 entities flagged for consolidation, same threshold
  // as the "Vue groupe" option in EntitySelector.
  const showRefacturation = !isLoading && groupEligible.length >= 2;
  // In group scope, Ventes shows as soon as one group-eligible entity has Shopify.
  const showVentes = !isLoading && (
    isGroup ? groupEligible.some((m) => m.has_shopify) : Boolean(activeMembership?.has_shopify)
  );
  return NAV_ITEMS.filter((item) => {
    if (item.requires === 'group') return showRefacturation;
    if (item.requires === 'shopify') return showVentes;
    return true;
  });
}

export function isNavItemActive(item, pathname) {
  if (item.exact) return pathname === item.to;
  return pathname === item.to || pathname.startsWith(item.to + '/');
}
